
<div class="toolbar-actions--translation-actions">
  <div class="toolbar-actions--translation-action" matRipple [class.active]="(service.currentLang$ | async) === 'en'" (click)="service.changeLanguage('en')">English</div>
  <div class="toolbar-actions--translation-action" matRipple [class.active]="(service.currentLang$ | async) === 'es'" (click)="service.changeLanguage('es')">Español</div>
</div>

<p translate="custom-activity-dialog.toolbar.label"></p>

<ui-action-button [size]="(service.actionButtonSize$ | async)!" [pending]="(stateService.formProcessing$$ | async)!" (click)="actionClicked.emit()" >{{ 'custom-activity-dialog.toolbar.action-button-text' | translate }}</ui-action-button>
